import { render, staticRenderFns } from "./CustomerForm.vue?vue&type=template&id=41c2ae1e&"
import script from "./CustomerForm.vue?vue&type=script&lang=js&"
export * from "./CustomerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41c2ae1e')) {
      api.createRecord('41c2ae1e', component.options)
    } else {
      api.reload('41c2ae1e', component.options)
    }
    module.hot.accept("./CustomerForm.vue?vue&type=template&id=41c2ae1e&", function () {
      api.rerender('41c2ae1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sale/clients/components/CustomerForm.vue"
export default component.exports